import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import image_background from "../../../assets/img/2.jpg";
import { useEffect, useRef } from "react";
function MissionVission() {
  const parallaxRef = useRef(null);

  useEffect(() => {
    const section = parallaxRef.current;
    if (!section) return;

    const background = section.querySelector(".fmw-parallax-background");

    if (!background) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (reduceMotion) return;

    let frameId = null;

    const updateParallax = () => {
      frameId = null;

      const rect = section.getBoundingClientRect();
      const offset = (window.innerHeight - rect.top) * 0.15;

      background.style.transform = `translate3d(0, ${offset}px, 0)`;
    };

    const onScroll = () => {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(updateParallax);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    updateParallax();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <section
      ref={parallaxRef}
      id="featured-official"
      className="featured-official-section fmw-parallax"
    >
      <div
        className="fmw-parallax-background"
        style={{ backgroundImage: `url("${image_background}")` }}
        aria-hidden="true"
      />

      <div className="fmw-parallax-overlay" aria-hidden="true" />

      <div className="container fmw-parallax-content">
        <div className="row align-items-left justify-content-left">
          <div className="col-lg-8 text-start">
            <div className="textControler">
              <h1 className="text-light">
                <strong>TRANSFORMATION</strong>
              </h1>

              <h2 className="text-light">
                Connecting Communities Through Modern Road Infrastructure
              </h2>

              <h3 className="text-light fw-light mb-1 fmw-parallax-description">
                Connecting Communities Through Modern Road Infrastructure The
                Federal Ministry of Works is committed to developing,
                rehabilitating, and maintaining Nigeria’s road networks and
                bridges to enhance connectivity, promote economic growth, and
                improve the quality of life for all Nigerians. Through strategic
                planning, innovative engineering, sustainable construction
                practices, and effective public-private partnerships, the
                Ministry works to deliver safe, durable, and accessible road
                infrastructure that connects communities, facilitates trade, and
                supports national development. With a focus on quality,
                accountability, and timely project delivery, the Ministry
                remains dedicated to building a reliable road network that
                drives prosperity and connects Nigeria’s future.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVission;
